import { MobileService } from '@common/lib/api';
import * as mobile from './types';

const actions = {
  // 통신사 목록 가져오기
  async [mobile.SELECT_MOBILE_TELECOMS](context, params) {
    const { data } = await MobileService.getTelecoms(params);
    context.commit(mobile.SET_MOBILE_TELECOMS, data);
    return data;
  },

  // 단말 카테고리 목록 가져오기
  async [mobile.SELECT_MOBILE_CATEGORY](context, params) {
    const { data } = await MobileService.getCategory(params);
    context.commit(mobile.SET_MOBILE_CATEGORY, data);
    return data;
  },

  // 단말 목록 가져오기
  async [mobile.SELECT_MOBILE_DEVICE](context, params) {
    const { data } = await MobileService.getDevice(params);
    context.commit(mobile.SET_MOBILE_DEVICE, data);
    return data;
  },

  // 단말 정보 가져오기
  async [mobile.SELECT_MOBILE_DEVICE_DETAIL](context, params) {
    const { data } = await MobileService.getDeviceDetail(params);
    context.commit(mobile.SET_MOBILE_DEVICE_DETAIL, data);
    return data;
  },

  // 요금 카테고리 가져오기
  async [mobile.SELECT_MOBILE_PLAN_CATEGORY](context, params) {
    const { data } = await MobileService.getPlanCategory(params);
    context.commit(mobile.SET_MOBILE_PLAN_CATEGORY, data);
    return data;
  },

  // 요금 목록 가져오기
  async [mobile.SELECT_MOBILE_PLANS](context, params) {
    const { data } = await MobileService.getPlans(params);
    context.commit(mobile.SET_MOBILE_PLANS, data);
    return data;
  },

  // 요금 정보 가져오기
  async [mobile.SELECT_MOBILE_PLAN_DETAIL](context, params) {
    const { data } = await MobileService.getPlanDetail(params);
    context.commit(mobile.SET_MOBILE_PLAN_DETAIL, data);
    return data;
  },

  // 견적요청
  async [mobile.INSERT_MOBILE_REQUESTS](context, params) {
    const { data } = await MobileService.setRequests(params);
    return data;
  },

  // 견적 보내는 쿠폰 조회
  async [mobile.SELECT_MOBILE_COUPON](context, params) {
    const { data } = await MobileService.getMobileCoupon(params);
    return data;
  },

  // 견적요청 목록
  async [mobile.SELECT_MOBILE_REQUEST_LIST_ING](context, params) {
    const { data } = await MobileService.getRequestList(params);
    context.commit(mobile.SET_MOBILE_REQUEST_LIST_ING, data);
    return data;
  },

  // 견적요청 목록
  async [mobile.SELECT_MOBILE_REQUEST_LIST_END](context, params) {
    const { data } = await MobileService.getRequestList(params);
    context.commit(mobile.SET_MOBILE_REQUEST_LIST_END, data);
    return data;
  },

  // 견적요청 상세정보
  async [mobile.SELECT_MOBILE_REQUEST_VIEW](context, params) {
    const { data } = await MobileService.getRequestView(params);
    context.commit(mobile.SET_MOBILE_REQUEST_VIEW, data);
    return data;
  },

  // 견적요청 마감하기
  async [mobile.UPDATE_MOBILE_REQUEST_CLOSE](context, params) {
    const { data } = await MobileService.setRequestClose(params);
    return data;
  },
  // 견적수신함 리스트
  async [mobile.SELECT_MOBILE_ESTIMATE_LIST](context, params) {
    const { data } = await MobileService.getEstimateList(params);
    context.commit(mobile.SET_MOBILE_ESTIMATE_LIST, data);
    return data;
  },
  // 견적수신함 리스트
  async [mobile.SELECT_MOBILE_ESTIMATE_GROUP_LIST](context, params) {
    const { data } = await MobileService.getEstimateGroupList(params);
    context.commit(mobile.SET_MOBILE_ESTIMATE_GROUP_LIST, data);
    return data;
  },

  // 견적수신함 상세정보
  async [mobile.SELECT_MOBILE_ESTIMATE_DETAIL](context, params) {
    const { data } = await MobileService.getEstimateDetail(params);
    context.commit(mobile.SET_MOBILE_ESTIMATE_DETAIL, data);
    return data;
  },

  // 요금제 변경
  async [mobile.UPDATE_MOBILE_PLAN](context, params) {
    const { data } = await MobileService.setPlanUpdate(params);
    return data;
  },

  // 부가서비스 목록
  async [mobile.SELECT_MOBILE_SERVICE_LIST](context, params) {
    const { data } = await MobileService.getServiceList(params);
    context.commit(mobile.SET_MOBILE_SERVICE_LIST, data);
    return data;
  },

  // 혜택보내기 (사장님)
  async [mobile.INSERT_MOBILE_ESTIMATE](context, params) {
    const { data } = await MobileService.setEstimates(params);
    return data;
  },

  // 미리보기 (사장님)
  async [mobile.SELECT_MOBILE_ESTIMATE_PREVIEW](context, params) {
    const { data } = await MobileService.preViewEstimates(params);
    context.commit(mobile.SET_MOBILE_ESTIMATE_PREVIEW, data);
    return data;
  },

  // 방문약속 등록 (사용자)
  async [mobile.INSERT_MOBILE_PROMISE](context, params) {
    const { data } = await MobileService.setPromise(params);
    return data;
  },

  // 방문약속 상세
  async [mobile.SELECT_MOBILE_PROMISE](context, params) {
    const { data } = await MobileService.getPromise(params);
    context.commit(mobile.SET_MOBILE_PROMISE, data);
    return data;
  },

  // 방문약속 목록
  async [mobile.SELECT_MOBILE_PROMISE_LIST](context, params) {
    const { data } = await MobileService.getPromiseList(params);
    context.commit(mobile.SET_MOBILE_PROMISE_LIST, data);
    return data;
  },

  // 새로운 혜택 건수
  async [mobile.SELECT_MOBILE_ESTIMATE_NEW_CNT](context, params) {
    const { data } = await MobileService.getEstimateNewCnt(params);
    context.commit(mobile.SET_MOBILE_ESTIMATE_NEW_CNT, data);
    return data;
  },

  // 견적요청 마감하기
  async [mobile.UPDATE_MOBILE_ESTIMATE_VISIBLE](context, params) {
    const { data } = await MobileService.setEstimateVisible(params);
    return data;
  },

  // 방문약속 새로운 건수
  async [mobile.SELECT_MOBILE_PROMISE_NEW_CNT](context, params) {
    const { data } = await MobileService.getPromiseNewCnt(params);
    context.commit(mobile.SET_MOBILE_PROMISE_NEW_CNT, data);
    return data;
  },

  // 의무 보험 목록
  async [mobile.SELECT_MOBILE_INSURANCE_LIST](context, params) {
    const { data } = await MobileService.getInsuranceList(params);
    context.commit(mobile.SET_MOBILE_INSURANCE_LIST, data);
    return data;
  },

  // 휴대폰 스펙 찾기
  async [mobile.SELECT_MOBILE_PRODUCTS](context, params) {
    const { data } = await MobileService.getMobileProducts(params);
    return data;
  },

  // 상품 찜하기 / 찜해제
  async [mobile.UPDATE_MOBILE_BOOKMARK](contenxt, params) {
    const { data } = await MobileService.setBookmark(params);
    return data;
  },

  //상품 조회 처리 (카운트 증가)
  async [mobile.UPDATE_MOBILE_VIEW_PRODUCT](context, params) {
    await MobileService.setViewProductCnt(params);
  },

  //상품 견적 요청처리 (카운트 증가)
  async [mobile.UPDATE_MOBILE_SEL_PRODUCT](context, params) {
    await MobileService.setSelProductCnt(params);
  },

  // 모바일 견적요청 건수
  async [mobile.SELECT_MOBILE_REQUEST_CNT](context, params) {
    const { data } = await MobileService.getMobileRequestCnt(params);
    return data;
  },

  // 휴대폰 개통신청서(비대면)
  async [mobile.CREATE_MOBILE_APPLY_ONLINE](context, params) {
    const { data } = await MobileService.setApplyOnline(params);
    return data;
  },

  // 휴대폰 개통신청서(매장방문)
  async [mobile.CREATE_MOBILE_APPLY_VISIT](context, params) {
    const { data } = await MobileService.setApplyVisit(params);
    return data;
  },

  // 휴대폰 개통신청서 목록
  async [mobile.SELECT_MOBILE_APPLY_LIST](context, params) {
    const { data } = await MobileService.getApplyList(params);
    return data;
  },

  // 휴대폰 개통신청서 상세정보
  async [mobile.SELECT_MOBILE_APPLY_DETAIL](context, params) {
    const { data } = await MobileService.getApplyDetail(params);
    return data;
  },

  // 휴대폰 채팅방 견적 리스트
  async [mobile.SELECT_MOBILE_CHAT_ESTIMATE_LIST](context, params) {
    const { data } = await MobileService.getChatEstimateList(params);
    context.commit(mobile.SET_MOBILE_CHAT_ESTIMATE_LIST, data);
    return data;
  },

  // 휴대폰 신청서 상태 조회 (열람, 제한, 취소, 입금 여부, 열람권 수량")
  async [mobile.SELECT_MOBILE_APPLY_STATUS](context, params) {
    const { data } = await MobileService.getApplyStatus(params);
    return data;
  },

  // 휴대폰 신청서 취소
  async [mobile.UPDATE_MOBILE_APPLY_CANCEL](context, params) {
    const { data } = await MobileService.setApplyCancel(params);
    return data;
  },

  // 휴대폰 신청서 새로운 건수
  async [mobile.SELECT_MOBILE_APPLY_CNT_NEW](context, params) {
    const { data } = await MobileService.getApplyNewCnt(params);
    context.commit(mobile.SET_MOBILE_APPLY_CNT_NEW, data);
    return data;
  },

  // 휴대폰 요금제 & 부가서비스 & 보험 즐겨찾기 / 해제
  async [mobile.UPDATE_MOBILE_ITEM_BOOKMARK](contenxt, params) {
    const { data } = await MobileService.setItemBookmark(params);
    return data;
  },

  // 휴대폰 특가 목록
  async [mobile.SELECT_MOBILE_DEAL](context, params) {
    const { data } = await MobileService.getMobileDeal(params);
    return data;
  },

  // 휴대폰 특가 상세정보
  async [mobile.SELECT_MOBILE_DEAL_DETAIL](context, params) {
    const { data } = await MobileService.getMobileDealDetail(params);
    return data;
  },

  // 휴대폰 특가 상담하기
  async [mobile.MOBILE_DEAL_CHAT](context, params) {
    const { data } = await MobileService.mobileDealChat(params);
    return data;
  },

  // 휴대폰 최신견적 불러오기
  async [mobile.FETCH_MOBILE_ESTIMATE_RECENT](context, params) {
    const { data } = await MobileService.getMobileEstimateRecent(params);
    return data;
  },

  // 휴대폰 동일 견적 요청 건수 조회
  async [mobile.SELECT_MOBILE_REQUEST_SAME_COUNT](context, params) {
    const { data } = await MobileService.getMobileRequestSameCnt(params);
    return data;
  },
};

export default actions;
